import React from 'react';
import './AmbassadorPromoSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHandsHelping,
  faBullhorn,
  faUsers,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const AmbassadorPromoSection = () => {
  return (
    <section className="ambassador-section">
      <h2 className="ambassador-title">Join Our Ambassador Program</h2>
      <p className="ambassador-subtitle">
        Be a voice for verified access to quality drugs in your community.
      </p>

      <div className="ambassador-benefits">
        <div className="benefit-card">
          <FontAwesomeIcon icon={faBullhorn} className="benefit-icon" />
          <h3>Spread Awareness</h3>
          <p>Help promote access to reliable pharmacies and verified drugs.</p>
        </div>
        <div className="benefit-card">
          <FontAwesomeIcon icon={faUsers} className="benefit-icon" />
          <h3>Earn Recognition</h3>
          <p>Get featured on our platform and be rewarded for your advocacy.</p>
        </div>
        <div className="benefit-card">
          <FontAwesomeIcon icon={faHandsHelping} className="benefit-icon" />
          <h3>Make an Impact</h3>
          <p>Support better health outcomes in your local area.</p>
        </div>
      </div>

      <div className="ambassador-cta">
        <Link to="/AmbassadorRegister" className="cta-btn">
          <FontAwesomeIcon icon={faCheckCircle} /> Join now
        </Link>
        
      </div>
    </section>
  );
};

export default AmbassadorPromoSection;
